import React from "react";
import SuperSchoolUsersList from "./Lists/SuperSchoolUsersList";
import { Container } from "@mui/material";

const SchoolUsers = () => {
  return (
    <Container maxWidth="lg" style={{ marginTop: "100px" }}>
      <h1>SuperAdmin - School Users</h1>
      <SuperSchoolUsersList />
    </Container>
  );
};

export default SchoolUsers;
